export function slugifyBlogTitle(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80)
}

export function buildBlogPath(blog = {}, locale = "es") {
  const id = blog.Id || blog.id
  const title = blog.Titulo_Esp || blog.Titulo || blog.tittle
  const slug = slugifyBlogTitle(title)
  // Mismo patron que buildPropertyPath: si el locale activo es 'en',
  // prepende /en/ al path. Para 'es' (default) deja el path sin
  // prefix, igual que el resto del routing. Asi el toggle de idioma
  // mantiene al usuario en la misma vista de blog con el locale
  // correcto en vez de forzarlo a /es/.
  const basePath = `/blog/${id}${slug ? `/${slug}` : ""}`
  return locale === "en" ? `/en${basePath}` : basePath
}
